<template>
  <!-- <button>dfd</button> -->
  <!-- <span class="icon-chip"> -->
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }" style="display: flex; align-items: center; height: 100%;">
    <feather-icon icon="UserCheckIcon" svgClasses="h-5 w-5 hover:h-7 hover:w-7 mr-4 text-success cursor-pointer"
      @click="confirmApprovedRecord" />
    <feather-icon icon="UserXIcon" svgClasses="h-5 w-5 mr-4 text-warning cursor-pointer"
      @click="confirmRejectedRecord" />
    <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 text-primary cursor-pointer" @click="$router.push(url)" />
    <!-- </span> -->
  </div>
</template>

<script>
import { ref } from 'vue';
import handlingError from '@/handlingError/handlingError.js';
export default {
  name: "CellRendererActions",
  setup() {
    const modalActive = ref(false);
    return { modalActive }
  },
  computed: {
    url() {
      return '/engineer/engineer-view/' + this.params.data.referUser._id;

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  },
  methods: {
    confirmApprovedRecord() {

      console.log("confirmRejectRecird")
      const data = {
        id: this.params.data._id,
        status: 'Approved',
        statusComment: '',
      }
      this.$store
        .dispatch("referManagement/changeReferStatus", data)
        .then((res) => {
          this.$router.push({ name: 'Refresh Router' });
        })
        .catch(err => {
          handlingError.handleError(err);
          console.error(err)
        });
  },
  confirmRejectedRecord() {
    this.params.data.temp(this.params.data)
  },
  confirmDeleteRecord() {
    this.params.data.temp(this.params.data)
    // this.$vs.dialog({
    //   type: "alert",
    //   color: "danger",
    //   title: "Confirm Delete",
    //   text: `You are about to delete "${this.params.value}"`,
    //   accept: this.deleteRecord,
    //   acceptText: "Delete",
    // });
  },
  showDeleteSuccess() {
    this.$vs.notify({
      color: "success",
      title: "User Deleted",
      text: "The selected user was successfully deleted",
    });
  },
},
};
</script>
<style>
.icon-chip {
  /* background-color: dodgerblue; */

}
</style>